export default "__VITE_ASSET__DaCOQbI2__"